module.exports = __webpack_public_path__ + "europa-20_microprint.jpg?81a534f96cca78357d21afab2bbbcd3b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20_microprint.jpg
// module id = 335
// module chunks = 0